import React, { useCallback, useState } from 'react';
import { eSigningMethod } from '../../../../../../types/signingAppointment/eSigningMethod';
import { SubHeaderTextTW } from '../../../../../../tailwindComponents/subHeaderText/SubHeaderTextTW';
import { Show } from '../../../../../shared/Show';
import { NotaryDetailsSection, shouldSkipNotaryDetails } from '../../NotaryDetails/NotaryDetailsSection';
import { EditNotaryForm } from '../../Forms/EditNotaryForm';
import { ISigningAppointmentEditFormData } from '../../../../../../types/signingAppointment/ISigningAppointmentEditFormData';
import { BadgeTW } from '../../../../../../tailwindComponents/badgeTW/BadgeTW';
import { CheckIcon } from '@heroicons/react/20/solid';
import { useSelectAppointmentFromPathParam } from '../../../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { attorneyOrNotary } from '../../../../../../utilities/order/scheduling/attorneyOrNotary';

export interface IAppointmentNotaryProps {
  onSaveEditions: (formData: ISigningAppointmentEditFormData) => Promise<void>;
  iconClassNames: string;
}

export const AppointmentNotary: React.FC<IAppointmentNotaryProps> = ({ onSaveEditions, iconClassNames }) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();
  const [updateNotary, setUpdateNotary] = useState<boolean>(false);

  const onUpdateNotaryClick = useCallback(() => {
    setUpdateNotary(true);
  }, [setUpdateNotary]);

  const onCloseNotaryEditionForm = useCallback(() => {
    setUpdateNotary(false);
  }, [setUpdateNotary]);

  if (
    !appointmentFromPath ||
    (appointmentFromPath.isDigitalScheduling &&
      appointmentFromPath.signingMethod === eSigningMethod.notaryOnly &&
      !appointmentFromPath.isDigitalSchedulingConfirmed)
  ) {
    return null;
  }

  const { notary } = appointmentFromPath;

  return (
    <Show
      when={
        appointmentFromPath.signingMethod !== eSigningMethod.eSign &&
        appointmentFromPath.signingMethod !== eSigningMethod.wetSign
      }
    >
      <section data-test-id={'appointment-details-tab-notary'}>
        <div className={'mb-4 flex flex-row justify-start'}>
          <Show when={!shouldSkipNotaryDetails(appointmentFromPath)}>
            <SubHeaderTextTW className={'mr-5'}>{attorneyOrNotary(appointmentFromPath.signingMethod)}</SubHeaderTextTW>
          </Show>
          <Show when={!!appointmentFromPath.isConfirmed}>
            <BadgeTW className="bg-green-100 text-green-800">
              <CheckIcon className={iconClassNames} />
              Signing Confirmed
            </BadgeTW>
          </Show>
        </div>
        <div>
          <NotaryDetailsSection onUpdateNotaryClick={onUpdateNotaryClick} />
          <Show when={updateNotary}>
            <EditNotaryForm
              onSave={onSaveEditions}
              onClose={onCloseNotaryEditionForm}
              notary={notary}
              signingAppointmentId={appointmentFromPath.id}
              title={`${notary ? 'Edit' : 'Add'} ${attorneyOrNotary(appointmentFromPath.signingMethod)}`}
            />
          </Show>
        </div>
      </section>
    </Show>
  );
};
